import { render } from "./DossierView.vue?vue&type=template&id=37236310&scoped=true"
import script from "./DossierView.vue?vue&type=script&lang=js"
export * from "./DossierView.vue?vue&type=script&lang=js"

import "./DossierView.vue?vue&type=style&index=0&id=37236310&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37236310"]])

export default __exports__